import { render, staticRenderFns } from "./PartnerCurrentList.vue?vue&type=template&id=d99df7a6&scoped=true&"
import script from "./PartnerCurrentList.vue?vue&type=script&lang=js&"
export * from "./PartnerCurrentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99df7a6",
  null
  
)

export default component.exports